import { useTranslation } from "react-i18next";
import type { TFunction } from "i18next";
import { CommandSeparator } from "@/components/ui/command";

const buildHints = (t: TFunction) => [
  { keys: "↑↓", label: t("common:chrome.navigate") },
  { keys: "↵", label: "open" },
  { keys: "esc", label: "dismiss" },
];

export const SearchFooter = () => {
  const { t } = useTranslation(["common"]);

  return (
    <>
      <CommandSeparator />
      <div className="flex items-center justify-end gap-4 px-3 py-2">
        {buildHints(t).map(({ keys, label }) => (
          <span
            key={label}
            className="flex items-center gap-1 text-xs text-muted-foreground"
          >
            <kbd className="rounded-xxs border border-border bg-background px-1 py-0.5 font-mono text-[10px] leading-none shadow-sm">
              {keys}
            </kbd>
            {label}
          </span>
        ))}
      </div>
    </>
  );
};
